// extracted by mini-css-extract-plugin
module.exports = {"bar":"label-with-edit-button_bar__25ZGG","label":"label-with-edit-button_label__1u0By","edit":"label-with-edit-button_edit__2ekPw"};